import type { LandingDict } from './en';

const ja: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "アプリを作成", org: "My Org", pricing: '料金', privacy: "プライバシー", contact: "お問い合わせ", language: '言語' },
  hero: {
    titlePre: 'あなただけの\n',
    titleMark: 'ローカル AI',
    titlePost: '環境。',
    sub: "専門知識、スプレッドシート、会議を、答え、グラフ、スライドに。データは Mac の外に出ません。",
    watch: "2 分の動画を見る",
    pill: "最新リリース",
    chip: "Wi‑Fi オフ · 送信 0 バイト",
    badges: { offline: "オフラインで動作", server: "サーバーはあなたのもの", free: "無料で始める" },
    reqs: 'Apple シリコン搭載の Mac が必要 · メモリ 16GB 以上 · 32GB 以上でより大きな推奨モデルを利用可能',
  },
  stats: {
    free: '無料',
    freeSub: 'すべての Chat Apps、モデルのダウンロード、アップデート。ずっと無料です',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'この Mac で AI を実行するとき、クラウドへ送られるデータ量',
    langsSub: 'の表示言語に対応。日本語、English、中文ほか',
  },
  film: { kicker: 'フィルム', title: 'Estha の実力を、その目で。', watchOnYouTube: 'YouTube で見る', trouble: '再生できない場合は YouTube でご覧ください ↗' },
  overview: {
    kicker: 'ひとつのアプリに、4 つの使い方',
    title: 'チャットから、エージェント、\nそしてチーム全員が使うアプリまで。',
    explore: '詳しく見る',
    chat: { title: 'Chat Apps', desc: '厳選された知識ベース（教科書、実践ガイド、専門知識）に基づく AI エキスパート。', tag: 'ずっと無料' },
    agentic: { title: 'Agentic Apps', desc: '複雑な作業を最初から最後まで処理する、タスク指向の AI エージェント。', tag: '{n} 種類、さらに追加予定' },
    build: { title: "アプリを作成", desc: 'Quick Bot で手持ちの資料を Chat App に。Playground のキャンバスで自由にフローを組むこともできます。', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: '組織専用のブランド化されたアプリスペース。審査済みのアプリを、アクセスを管理しながら届けます。', tag: 'エンタープライズ' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: '確かな知識に基づく、AI エキスパート。',
    freePill: 'ずっと無料',
    lede: 'Chat App にはそれぞれ専用の知識ベースが付属し、あなたの Mac 上でインデックス化されます。',
    feats: {
      kb: { title: 'ローカルの知識ベース', desc: 'アプリをインストールすると知識ベースがローカルに作成され、厳選された資料をもとに回答します。' },
      files: { title: '手持ちのファイルも活用', desc: '画像、PDF、DOCX、TXT、MD を添付可能。長い文書はスマート検索で処理します。' },
      browse: { title: '探す、ピン留め、お気に入り', desc: 'アセスメントからキャリアまでのカテゴリ、新着アプリには NEW タグ、⌘K ですべてを検索。' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} つの Agentic Apps。\nこれからも、さらに。',
    lede: 'スプレッドシート、PDF、録音、あるいはアイデアから、完成したグラフ、スライド、文書、プロトタイプへ。すべてあなたの Mac 上で、プライベートに。',
    seeThem: '実際の動きを見る',
  },
  build: {
    kicker: 'アプリを作成',
    title: '自分だけの Chat App を。\nあなたの Mac の上で。',
    lede: '手持ちのファイルを Chat App に。インデックス化はローカルで、公開は準備ができたときに。',
    quick: {
      badge: 'おすすめ',
      desc: 'ナレッジベースをアップロードしてシステムプロンプトを書き、公開するだけ。資料をすばやく Q&A ボットにするのに最適です。',
      items: ['1 ページのフォーム、数ステップで完了', 'そのまま使えるナレッジベース Q&A', 'インスピレーションになる組み込みプロンプトテンプレート'],
    },
    advanced: {
      title: 'アドバンスド · Playground',
      desc: 'ビジュアルノードエディターで、複数のノード、分岐、AB test、キーワードルーティングを自由に組み合わせられます。',
      items: ['ノードキャンバス', 'マルチノード / 分岐 / AB test', '細かなフィールド設定とデバッグ'],
    },
    guideTitle: 'ローカル AI の作成ガイドが、そばでサポート。',
    guideText: 'アプリにさせたいことを伝えれば、どのノードをドラッグし、どうつなげばよいかを案内します。アプリ作成はプレミアムに含まれています。',
  },
  private: {
    kicker: 'プライバシー設計',
    title: "データはクラウドへ送らない。\n作業は追跡しない。",
    lede: "AI をどこで動かすかはあなたが決めます。Estha は機能ごとに最適なモデルを自動で選び、アプリ内でいつでも切り替えられます。",
    boundary: "データの境界 = あなたのネットワーク",
    local: { title: 'この Mac 上で', desc: '完全オフラインで、データはこの端末から出ません。このコンピュータのメモリでモデルを実行します。', best: 'メモリに余裕のある Mac におすすめ' },
    server: { title: '自分の Estha Server 上で', desc: '重い処理をネットワーク上の高性能な Mac に任せ、この Mac を軽く保ちます。', best: 'ノート型やメモリの少ない Mac におすすめ' },
    cluster: { desc: 'Mac Studio クラスターに接続して、データを社内に保持しながら重い推論をオフロードします。', best: 'ネットワーク上の Estha Studio Master ノードを自動検出' },
    models: {
      every: 'サポート対象のすべての Mac で動作',
      whisper: "文字起こしには Whisper",
      recommended: '推奨モデル',
      larger: "より大きな Qwen・Gemma モデル",
      vision: "画像を理解するビジョンモデル",
      open: 'Apple シリコンに最適化されたオープンモデル',
      openItems: ['アプリ内でモデルをダウンロード・切り替え', 'コーディング用・埋め込み用の専用モデル', 'モデルのダウンロードはずっと無料'],
    },
  },
  org: {
    kicker: 'My Org',
    title: '組織専用の AI アプリスペース。',
    lede: 'Estha の中に、組織のブランドをまとった専用セクションを。メンバーのために審査したアプリを並べられます。',
    signIn: 'My Org Admin にサインイン',
    talk: 'Estha チームに相談する',
    feats: {
      review: { title: '公開前にレビュー', desc: '新規アプリ、アップデート、削除はすべて管理者の承認が必要です。却下時には必ずコメントが添えられます。' },
      access: { title: 'グループ・個人単位のアクセス管理', desc: '部署、チーム、個人ごとに、各アプリを誰が使えるかを細かく設定できます。' },
      brand: { title: 'アプリの中に、あなたのブランドを', desc: '組織名、ウェルカムメッセージ、ロゴ、バナー、テーマカラー。公開前にプレビューで確認できます。' },
    },
  },
  pricing: {
    kicker: 'メンバーシップ',
    title: 'まずは無料で。\n必要なときに、すべてを解放。',
    free: { name: '無料', sub: 'ずっと無料。', items: ["すべての Chat Apps", 'ドキュメント処理はずっと無料', 'モデルのダウンロード、ソフトウェア、アップデートは常に無料'] },
    premium: {
      name: 'プレミアム', flag: '14 日間無料トライアル', firstYear: '初年度',
      sub: '2 年目以降は年額 $30。メールアドレスの認証後、14 日間の無料トライアルから始められます。',
      items: ['無料プランのすべての権限', '現在および将来のすべての Agentic Apps', 'Chat App ビルダー — ローカルチャットボットの作成・編集・プレビュー・保存・公開'],
      cta: 'アプリ内でトライアルを開始',
    },
    enterprise: {
      name: 'エンタープライズ', price: 'お問い合わせ', sub: 'チームに Estha を導入する組織向け。',
      items: ['プレミアムプランのすべての権限', 'チーム向けにカスタマイズされた Chat Apps と Agentic Apps', 'Estha Server アプリ機能', 'My Org アプリスペースと My Org Admin'],
    },
  },
  faq: {
    title: 'ダウンロードの前に、\n知っておきたいこと。',
    spec: { chip: 'チップ', memory: 'メモリ', memMin: '16GB 以上', memRec: '推奨モデルには 32GB 以上', languages: '言語', langsVal: '13 の表示言語', version: '最新バージョン' },
    qa: [
      { q: 'データが Mac の外に出ることはありますか？', a: 'この Mac で AI を実行する場合は完全オフラインで、データが端末の外に出ることはありません。Estha Server や Mac Studio クラスターを選んだ場合も、処理が送られるのは自分のネットワーク内のそのマシンだけです。' },
      { q: "インターネット接続が必要なのは？", a: "ごく一部だけです。Premium トライアルのサインインとメール認証、モデルのダウンロード、アップデートの確認。プロンプト、ファイル、結果がアップロードされることはありません。モデルをダウンロードすれば、AI は完全にオフラインで動きます。" },
      { q: '無料で使える範囲と、プレミアムの違いは？', a: 'すべての Chat Apps、ドキュメント処理、モデルのダウンロードとアップデートは無料です。プレミアムでは現在および将来のすべての Agentic Apps と Chat App ビルダーが使えるようになり、14 日間の無料トライアルもあります。' },
      { q: 'どの AI モデルを使っていますか？', a: 'Qwen や Gemma などの主要なオープンソースモデルと、文字起こし用の Whisper を、Apple の MLX エンジンで実行します。モデルはアプリ内でダウンロード・切り替えできます。' },
      { q: '自分でアプリを作れますか？', a: 'はい。Quick Bot なら最大 3 つのファイルから、数ステップで知識ベース付きの Chat App を作れます。Playground のノードキャンバスを使えば、分岐、AB test、クイズも作成可能。ローカルの作成ガイドが途中でサポートします。' },
      { q: '組織への導入方法は？', a: 'エンタープライズでは、管理者が My Org Admin でユーザーとグループを管理し、すべてのアプリを公開前にレビューします。メンバーは Estha の中でブランド化された My Org スペースを利用できます。お問い合わせは {email} まで。' },
    ],
  },
  final: { title: 'AI を、ローカルで動かそう。', reqs: 'Apple シリコン搭載のすべての Mac で動作 · メモリ 16GB 以上' },
  footer: {
    tagline: 'あなただけのローカル AI 環境。オンデバイス、MLX 搭載、プライバシー設計。',
    product: '製品', createApp: 'アプリを作成', pricing: '料金',
    orgs: "My Org", signIn: 'My Org Admin にサインイン',
    security: "セキュリティ", changelog: "更新履歴", docs: "ドキュメント", support: "サポート",
    company: '会社情報', privacy: 'プライバシーポリシー', terms: '利用規約',
    rights: '© 2026 Estha. All rights reserved.',
  },
  proof: { press: "掲載メディア", voices: "チームの声" },
  contact: {
    title: "Estha チームにメール", copy: "メールアドレスをコピー", copied: "コピーしました",
    gmail: "Gmail で作成", mailApp: "メールアプリで開く",
    subject: "Estha for Mac へのお問い合わせ",
  },
  share: {
    button: "シェア", title: "Estha をシェア",
    sub: "カードを選んで投稿するか、リンクだけ送りましょう。",
    style: "カード", size: "サイズ",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "プライバシー" },
    landscape: "横長", portrait: "縦長",
    shareImage: "画像をシェア…", download: "画像を保存", copyImage: "画像をコピー", copied: "コピーしました",
    copyLink: "リンクをコピー", link: "リンク", postTo: "投稿先",
    email: "メール",
    text: "Estha は、オープンソースの AI モデルを Mac の中だけで動かします。プライベート、オフライン対応、無料でダウンロードできます。",
    cardCta: "無料ダウンロード · Apple シリコン搭載 Mac 対応",
    close: "閉じる",
  },
  apps: {
    dataAnalyst: { name: 'データアナリスト', description: 'CSV / Excel ファイルをアップロードし、自然言語で質問できます。グラフ、統計分析、データインサイトを自動生成し、すべて Mac 上でローカルに処理します。', tags: ['CSV / Excel', '自動グラフ', '自然言語クエリ', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'プレゼンテーションのテーマを説明するだけで、専門的に構成された PowerPoint を作成します。複数ステップの AI パイプラインがアウトライン、各スライドの内容、洗練された .pptx ファイルを生成します。', tags: ['.pptx 出力', '自動レイアウト', '複数ステップパイプライン'] },
    pdfReader: { name: 'PDF リーダー', description: 'PDF を開いてそのまま質問。回答はすべて文書の原文に基づき、クリックで出典箇所へジャンプできる引用付き —— すべて Mac 上でローカル処理。', tags: ['PDF 質問応答', '検証可能な引用', '選択して質問', '100% ローカル'] },
    documentProcessing: { name: 'ドキュメント処理', description: 'あらゆる文書作業に対応するドキュメントエキスパート。ブログ記事、SNS 投稿、法的条項、ビジネス文書をゼロから作成。既存ファイルの編集・最適化、言語間の翻訳、品質チェックまで、すべて Mac 上でプライベートに行えます。', tags: ['作成・執筆', '編集・最適化', '翻訳', 'レビュー・監査'] },
    meetingIntelligence: { name: 'ミーティングインテリジェンス', description: 'AI で会議を録音、文字起こし、分析します。議事録、アクションアイテム、重要な決定事項を自動生成。完全なプライバシーを確保し、音声がデバイス外に出ることはありません。', tags: ['文字起こし', '議事録', 'アクションアイテム', '100% プライベート'] },
    vibeCoding: { name: 'Vibe Coding：プロトタイプ', description: 'AI でインタラクティブなプレビューを作成。自然言語で画面を説明するとクリックできるプロトタイプが得られ、そのまま反復改善できます。最終的に単一の自己完結型 .html ファイルを出力 —— すべて Mac 上でローカル生成。', tags: ['単一 .html ファイル', 'インタラクティブプレビュー', 'クリックして編集', '100% ローカル'] },
    translate: { name: "翻訳", description: "テキストや Word・テキスト・Markdown 文書を翻訳。共有の用語集で訳語を統一し、すべて Mac 上でローカルに処理します。", tags: ["テキストと文書", ".docx / .txt / .md", "用語集", "100% ローカル"] },
  },
  screens: {
    chat: [
      { label: 'ストアを見る', caption: '探す、インストール、ピン留め。ずっと無料' },
      { label: 'インストール', caption: 'インストール時に知識ベースをローカルに作成' },
      { label: '質問する', caption: '専門の知識ベースに基づいて回答' },
    ],
    build: [
      { label: 'アプリを作成', caption: 'Quick Bot でもアドバンスドでも、すぐにチャット可能' },
      { label: 'Quick Bot', caption: 'ナレッジベースをアップロード。プロンプトを書いて、公開。' },
      { label: 'Playground', caption: 'ノード、分岐、知識をビジュアルに編集' },
      { label: '公開済み', caption: '公開完了、すぐにチャットできます' },
    ],
    analyst: [
      { label: '質問する', caption: 'データに自然言語で質問' },
      { label: '分析中', caption: 'あなたの Mac 上で分析' },
      { label: 'グラフとインサイト', caption: '答えとグラフ、そして分析の過程' },
    ],
    ppt: [
      { label: '設定', caption: 'テーマ、枚数、言語、トーン、デザイン' },
      { label: 'アウトライン確認', caption: '生成前にアウトラインを編集' },
      { label: 'プレビュー', caption: '編集可能な .pptx が、あなたの Mac で完成' },
    ],
    pdf: [
      { label: 'PDF を開く', caption: '論文、レポート、マニュアル、スキャン文書' },
      { label: '読み込み中', caption: '1 ページずつ、ローカルで読み込み' },
      { label: '出典付きの回答', caption: 'すべての回答が該当箇所を示します' },
    ],
    doc: [
      { label: '範囲を選択', caption: 'テキストを選んで、してほしいことを伝える' },
      { label: 'リライト中', caption: '文書の中でそのまま書き換え' },
      { label: '承認または却下', caption: '書き換え、推敲、翻訳。一つずつ承認または却下' },
    ],
    meeting: [
      { label: '録音', caption: 'この Mac でリアルタイムに文字起こし' },
      { label: '出力を選ぶ', caption: '生成する内容を選択' },
      { label: '要約', caption: '決定事項とアクションアイテムを自動でまとめ' },
      { label: 'アクションアイテム', caption: '担当者と期限を、根拠とともに' },
    ],
    vibe: [
      { label: '説明する', caption: '画面のイメージを自然言語で説明' },
      { label: '生成中', caption: 'すべてこの Mac 上で生成' },
      { label: 'プロトタイプ', caption: 'クリック操作もバージョン管理も、1 つの .html ファイルで' },
      { label: 'クリックして編集', caption: '任意の箇所を選んで、変更内容を伝えるだけ' },
    ],
    translate: [
      { label: "テキストを翻訳", caption: "紫の語句は用語集から" },
      { label: "文書を翻訳", caption: ".docx・.txt・.md — 元のファイルはそのまま" },
      { label: "用語集", caption: "用語集で訳語をいつも統一" },
    ],
    private: [
      { label: 'この Mac 上で', caption: '完全オフライン。データはこの端末から出ません。' },
      { label: 'Mac Studio Cluster', caption: 'より大きなモデルを、社内環境で' },
    ],
    org: [
      { label: '組織のアプリスペース', caption: 'ブランド化されたスペースに、チーム向けのアプリを' },
      { label: 'エンタープライズプラン', caption: 'メンバーは許可されたアプリだけを利用可能' },
    ],
  },
};

export default ja;
